<template>
    <div id="userTab">
        <div class="modal-header manage_header">
					<div class="modal-header pr-4 pl-2 pt-2 pb-0">
						<div class="" style="width: 100%;">
							<a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"  style="color: #6c757d !important;"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png"  />Back</a>
							<button type="button" class="close float-right" @click="hide">
								<span aria-hidden="true">&times;</span>
							</button>
							<div class="clearfix"></div>
						</div>
					</div>
					<div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        </div>
        <div class="modal-body user-info" v-if="loading == false">
					<b-alert
						:show="dismissAuthCountDown"
						dismissible
						variant="success"
						@dismissed="dismissAuthCountDown=0"
						@dismiss-count-down="countDownAuthChanged"
						>
						{{ success_auth_message }}
					</b-alert>
          <div class="row mb-4">
            <div class="col-9 pl-3">
              <div class="h5 mr-2">{{ display_firstName + ' ' + display_lastName }}</div>
              <div class="h5 mr-2">{{ display_email }}</div>
              <div class="h6 mr-2">{{ accountName }}</div>
            </div>
            <div class="col-3 pl-3 pr-4 text-right" v-if="displayMentorEdit == 0">
                <a class="link_btn ma-blue-btn" style="padding: 5px 25px; border-radius: 15px; color: #FFF !important;" @click="updateUser">Save</a>
            </div>
            <div class="col-3 pl-3 pr-4 text-right" v-if="displayMentorEdit == 1">
                <a class="link_btn ma-blue-btn" style="padding: 5px 25px; border-radius: 15px; color: #FFF !important;" @click="openMentorEditFormModal()">Edit</a>
            </div>
          </div>                            
            
					<div v-if="resetLinkSuccessMsg" class="text-green">{{ resetLinkSuccessMsg }}</div>
					<div v-if="statusUpdateSuccessMsg" class="text-green">{{ statusUpdateSuccessMsg }}</div>
            <div class="row edit_row" v-if="displayMentorEdit == 0">
                <div class="col-12">
                    <label for="" class="input_label">User Information <span class="required">*</span></label>
                    <p v-if="isUpdateMsg" class="text-green">User details are updated successfully</p>
                </div>
            </div>
            <div class="row edit_row"  v-if="displayMentorEdit == 0">
                <div class="col-6">
                    <input
                        type="first_name"
                        name="first_name"
                        class="col-12 col-sm-12 input-height-35 form-control"
                        ref="first_name"
                        v-validate="'required'"
                        v-model="firstName"
                        data-vv-as="First name"
                        maxlength="180">
                    <div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
                </div>
                <div class="col-6">
                    <input
                        type="last_name"
                        name="last_name"
                        class="col-12 col-sm-12 input-height-35 form-control"
                        ref="last_name"
                        v-validate="'required'"
                        v-model="lastName"
                        data-vv-as="Last name"
                        maxlength="180">
                    <div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
                </div>
            </div>
            <div class="row edit_row" style="margin-top: 10px;"  v-if="displayMentorEdit == 0">
                <div class="col-12">
                    <input
                        type="text"
                        name="email"
                        class="col-12 col-sm-12 input-height-35 form-control"
                        ref="email"
                        v-model="email"
                        data-vv-as="Email"
                        maxlength="180"
                        disabled="true">
                </div>
            </div>
            <div class="row edit_row" style="margin-top: 10px;"  v-if="displayMentorEdit == 0">
                <div class="col-12">
                    <input
                        type="text"
                        name="phone_number"
                        class="col-12 col-sm-12 input-height-35 form-control"
                        ref="phone_number"
                        v-model="phoneNo"
                        data-vv-as="Phone number"
                        maxlength="20"
                        @keyup="phoneNumberFormat()"
                        @blur="phoneNumberFormat()"
                        v-validate="{ rules: { regex: phoneNumberValidRegex() } }">
                    <div v-show="verrors.has('phone_number')" class="validate-warning-msg">{{ verrors.first('phone_number') }}</div>
                </div>
            </div>
            <div class="row edit_row"   v-if="displayMentorEdit == 0">
                <div class="col-2 text-center p-0">
                    <label for="" class="input_label">Password</label>
                    <div>
                        <a class="link_btn branding_text_color" @click="openResetLinkModal"> Reset</a>
                    </div>
                </div>
                <div v-if="(isCanAddTransfer == true && status == 'Active')" class="col-2 text-center">
                    <label for="" class="input_label">Add/Transfer</label>
                    <a class="offcanvas_link" @click="openTransferLinkModal"> 
                        <img src="@/assets/enterprise/Move_User_16x16.png">
                    </a>
                </div>
                <div class="col-2 text-center" v-if="userType == 'mentee' || userType == 'apprentice'">
                    <label for="" class="input_label">Status</label>
                    <div>
                        <a v-if="status == 'Active'" :class="'status_link ' + getFontColor(status)" @click="openStatusModal(status)"> {{ formatStatus(status) }}</a>
                    </div>    
                </div>
                <div class="col-2 text-center" v-else>
                    <label for="" class="input_label">Status</label>
                    <div>
                        <a :class="'status_link ' + getFontColor(status)" @click="openStatusModal(status)"> {{ formatStatus(status) }}</a>
                    </div>    
                </div>

            </div>
            <hr class="hr_line_2" v-if="displayMentorEdit == 0" />


            <div class="pad-15" v-if="((userType === 'mentor' || userType === 'mentee' || userType === 'manager') && (displayMentorEdit == 0))">
							<div class="row edit_row">
								<div class="assigned_heading_1 font-weight-bold">Assessments</div>
								<div class="assigned_heading_2 font-weight-bold text-center">Results</div>
								<div class="assigned_heading_3 font-weight-bold text-center">Access</div>
								<div class="clearfix"></div>
								<div v-if="assignedAssessmentsCount > 0" class="row_item_readonly">
									<div v-for="(item, acindex) in assignedAssessments" :key="acindex" class="row_data_border">
										<div class="assigned_heading_1">{{ item.title }}</div>
											<div class="assigned_heading_2 text-center">
												<router-link target="_blank" v-if="item.complete_attempt_id" :to="'/assessment-report/' + item.complete_attempt_id" class="link_btn_highlight branding_text_color">
													View
												</router-link>
												<span v-else>n/a</span>
											</div>
											<div class="assigned_heading_3 text-center">
												<div class="chkboxwrapper">
													<div class="custom-control custom-checkbox">
														<input 
																type="checkbox" 
																name="Assign Assessments"
																:id="'assign_assessment_' + acindex"
																:value="item.id"
																v-model="assessmentsSelected"
																class="custom-control-input"
																@click="getAssessmentSelected($event)">
														<label class="custom-control-label" :for="'assign_assessment_' + acindex"></label> 
													</div>
												</div>
											</div>
											<div class="clearfix"></div>
										</div>
                    </div>
                    <div v-if="assignedAssessmentsCount === 0">
											<div class="col-12 text-red mt-2">No Assessment Found.</div>
                    </div>
	                </div>
  	              <div class="row edit_row">
                    <div class="courses_head_1 font-weight-bold">Courses</div>
                    <div class="courses_head_2 font-weight-bold">Final Exam Score</div>
                    <div class="courses_head_3 font-weight-bold">Certificate</div>
                    <div class="courses_head_4 font-weight-bold text-center">Access</div>
                    <div class="clearfix"></div>
                    <div v-if="assignedCoursesCount > 0" class="row_item_readonly">
											<div v-for="(item, lacindex) in assignedCourses" :key="lacindex" class="row_data_border">
													<div class="courses_item_1">
														{{ item.title }}
														<span v-if=item.score>
														<a class="show_icon" :ref="'show_icon_'+lacindex" @click="getCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + lacindex, lacindex)">
																<img 
																		src="@/assets/enterprise/down_arrow_image16x16.png" 
																		width="16" 
																		height="16">
														</a>
														<a class="hide_icon" :ref="'hide_icon_'+lacindex" @click="hideCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + lacindex, lacindex)"> 
																<img 
																		src="@/assets/enterprise/up_arrow_image16x16.png" 
																		width="16" 
																		height="16">
														</a>
														</span>
													</div>
													<div class="courses_item_2 text-center">
														<span v-if="item.score">{{ item.score }}%</span>
														<span v-else>n/a</span>
													</div>
													<div class="courses_item_3 text-center" v-if="item.certification_download_link">
															<a :href="item.certification_download_link" target="_blank" class="link_btn_highlight branding_text_color">View</a>
													</div>
													<div class="courses_item_3 text-center" v-else>n/a</div>
													<div class="courses_item_4 text-center">
													<div class="chkboxwrapper">
														<div class="custom-control custom-checkbox">
															<input 
																	type="checkbox" 
																	name="Assign Course"
																	:id="'assign_course_' + lacindex"
																	:value="item.id" 
																	class="custom-control-input"
																	v-model="courseSelected"
																	@click="getCourseSelected($event)">
													<label class="custom-control-label" :for="'assign_course_' + lacindex"></label> 
														</div>
													</div>

													</div>
													<div class="clearfix"></div>
													<!-- modules start -->
													<div v-if=item.score>
													<CourseUserResultsModules
															:ref="'course_user_results_modules_' + lacindex"
													>
													</CourseUserResultsModules>
													</div>
													<!-- modules end -->
													<div class="clearfix"></div>
											</div>
									</div>
									<div v-if="assignedCoursesCount === 0">
											<div class="col-12 text-red mt-2" style="margin-bottom: 15px;">No Courses Found.</div>
									</div>
                </div>
                <div class="row edit_row" v-if="userType === 'mentee' || userType === 'apprentice'">
                    <div class="assigned_form_h1 font-weight-bold">Task Lists</div>
                    <div class="assigned_form_h2 font-weight-bold text-center">Access</div>
                    <div class="clearfix"></div>
                    <div v-if="assignedTaskListsCount > 0" class="row_item_readonly">
                        <div v-for="(item, acindex) in assignedTaskLists" :key="acindex" class="row_data_border">
                            <div class="forms_item_1">{{ item.name }}</div>
                            <div class="forms_item_2 text-center">
                            <div class="chkboxwrapper">
                              <div class="custom-control custom-checkbox">
                                <input 
                                    type="checkbox" 
                                    name="Assign TaskList"
                                    :id="'assign_tasklist_' + acindex"
                                    :value="item.id"
                                    v-model="taskListsSelected" 
                                    class="custom-control-input"
                                    @click="getTasklistSelected($event)">
                            <label class="custom-control-label" :for="'assign_tasklist_' + acindex"></label> 
                              </div>
                            </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="assignedTaskListsCount === 0">
                        <div class="col-12 text-red mt-2">No Task Lists Found.</div>
                    </div>
                </div>
							</div>


            	<div class="pad-15 mb-5 pr-0" v-if="((userType == 'mentor' || userType == 'mentee') && displayMentorEdit == 0) " style="padding-left: 0 !important;">
		           	<div class="col-12 p-0"  v-if="editPathwayList.length > 0" style="margin-top: 10px;">
									<label
										for="roles"
										class="col-12 p-0 bold">Assign Pathway: </label>
									<div class="col-12 p-0 col-sm-12 tasklist-assign-wrapper" v-for="(pathway, key, index) in editPathwayList">
										<div class="chkboxwrapper">
											<div class="custom-control custom-radio">
												<input 
													name="pathway_assigned"
													:value="pathway.id"                       
													type="radio" 
													v-model="editpathwaySelected"
													@change="pathwayChangedEvent()"
													v-validate="'required'"
													class="custom-control-input"
													:id="'edit_mentee_pathway_' + pathway.id"
													>
												<label class="custom-control-label" :for="'edit_mentee_pathway_' + pathway.id">{{ pathway.pathwayName }}</label>
											</div>
										</div>
									</div>
	                <div v-if="verrors.has('pathway_assigned')" class="margin-bottom-5 validate-warning-msg">Pathway is required</div>
           			</div>
								<div class="col-12 p-0"  v-if="editPathwayList.length > 0" style="margin-top: 10px;">
									<div class="row">
										<div class="col-8 p-0 d-inline"> 
											<label
													for="roles"
													class="col-12 bold">Begin at step: </label>
										</div>     
										<div class="col-4">
											<div class="chkboxwrapper">
												<div class="custom-control custom-checkbox">
													<input 
														name="future steps"
														value="1"                                           
														type="checkbox" 
														v-model="editShowFutureSteps"                      
														class="custom-control-input"
														:id="'edit_mentee_future_steps'" 
														>
													<label class="custom-control-label" :for="'edit_mentee_future_steps'">Show future steps</label>
												</div>
											</div>
										</div>
									</div> 
									<div class="col-12 p-0 col-sm-12 tasklist-assign-wrapper" v-for="(step, key, index) in pathwaySteps">
										<div class="chkboxwrapper">
											<div class="custom-control custom-radio">
												<input 
													name="step_assigned"
													:value="step.id"                       
													type="radio" 
													v-model="editStepSelected"                      
													v-validate="'required'"
													class="custom-control-input"
													:id="'edit_mentee_step_' + step.id"
													>
												<label class="custom-control-label" :for="'edit_mentee_step_' + step.id">{{ step.stepTitle }}</label>
											</div>
										</div>
									</div>
								</div>
								<div v-if="verrors.has('step_assigned')" class="margin-bottom-5 validate-warning-msg">Step is required</div>
							</div>

							<div class="pad-15 mb-5" v-if="((userType == 'mentor' || userType == 'mentee') && (pathwayProgressLoading == false))" style="padding-left: 0 !important;">
								<div>
									<div class="mt-1 mb-3 pl-3 pr-3">
										<div class="row align-items-end">
											<div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
												<p class="text-uppercase mb-1 " 
													:class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" @click="moveToStep(pathwayStep.id)" style="cursor: pointer;">
													<span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
												</p>
												<div class="progress progress_pathway">
													<div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
												</div>
											</div>        
										</div>
									</div>
								</div>

								<div class="pl-2 pr-2" v-if="activeStep != ''">
									<div class="text-muted">Mentor(s)</div>
										<ul class="list-inline">
											<li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
										</ul>                
								</div>

								<div v-if="activeStep != ''">
									<MenteeProgress
										:menteeId="menteeId"
										:stepId="activeStep"
										:accountId="accountId"
										:pathwayId="pathwayId"
										:type="1"
										ref="MenteeProgressComponent"
										@closeAddRep="closeAddRep"
										>
									</MenteeProgress>
								</div>


							</div>

		        </div>
						<div class="modal-footer"></div>
						<MentorEditForm
								:isModalVisible="isMentorEditFormModalVisible" 
								:userId="userId" 
								:accountId="accountId"
								ref="MentorEditForm"
								@close="closeMentorEditFormModal"
						/>

						<userResetLinkModal 
								:isModalVisible="isUserResetLinkModal" 
								ref="user_reset_modal_popup"
								@close="closeResetLinkModal"
						/>
						<UserActivateModal 
								:isModalVisible="isUserActivateModal" 
								ref="user_activate_modal"
								page_from="user_detail"
								@close="closeUserActivateModal"
						/>
						<UserInactivateModal
								:isModalVisible="isUserInactivateModal" 
								ref="user_inactivate_modal"
								page_from="user_detail"
								@close="closeUserInactivateModal"
						/>
						<AddTransferLinkModal 
								:isModalVisible="isTransferLinkModal" 
								ref="add_transfer_modal_popup"
								:accountName="accountName"
								:accountId="accountId"
								@close="closeTransferLinkModal"
						/>

    </div>
</template>
<script>
import axios from 'axios';
import userResetLinkModal from './loation_reset_modal.vue';
import UserActivateModal from './user_activate_modal.vue';
import UserInactivateModal from './user_inactivate_modal.vue';
import AddTransferLinkModal from './add_transfer_modal.vue';
import CourseUserResultsModules from './course_user_results_modules.vue';
import MenteeProgress from '@/components/enterpriseadmin/mentee_progress.vue';
import MentorEditForm from '@/components/enterpriseadmin/view_user_detail_manage_mentoredit.vue';

export default {
    props: ['userId', 'readOnly','isUserDetailPanel', 'accountId'],
    data() {
        return {
            display_firstName: '',
            display_lastName: '',
            display_email: '',
            firstName: '',
            lastName: '',
            email: '',
            phoneNo: '',
            status: '',
            accountName: '',
            userType:'',
            loading: false,
            status_text_color: 'text-green',
            assignedTaskLists: [],
            assignedTaskListsCount: 0,
            taskListsSelected: [],
            assignedAssessments: [],
            assignedAssessmentsCount: 0,
            assessmentsSelected: [],
            assignedCourses: [],
            assignedCoursesCount: 0,
            coursesSelected: [],
            assignedForms: [],
            assignedFormsCount: 0,
            isUpdateMsg: false,
            isUserResetLinkModal: false,
            resetLinkSuccessMsg: '',
            statusUpdateSuccessMsg: '',
            userInfo: {},
            isUserActivateModal: false,
            isUserInactivateModal: false,
            isTransferLinkModal: false,
            removedTasklists: [],
            removedCourses: [],
            removedAssessments: [],
            courseInfo: false,
            courses_modules: [],
            showModule: false,
            showIcon: [],
            course_msg: '',
						editPathwayList: [],
						pathwaySteps: [],
						editPathwaySelected: '',
						stepSelected: '',
						editShowFutureSteps: 0,
						defaultstep: '',
						editStepSelected: '',
						existingPathway: '',
						isCanAddTransfer: false,
						mentorsAssigned: [],
						pathwayStepsData: [],
						activeStep: '',
						pathwayId: '',
						menteeId: '',
						pathwayProgressLoading: false,
						success_auth_message: '',
						dismissAuthCountDown: 0,
						displayMentorEdit: 0,
						isMentorEditFormModalVisible: false,
        }
    },
    components: {
        userResetLinkModal,
        UserActivateModal,
        UserInactivateModal,
        AddTransferLinkModal,
        CourseUserResultsModules,
				MenteeProgress,
				MentorEditForm,
    },
    methods: {
			pathwayChangedEvent() {
				this.getPathwaySteps();
				this.editStepSelected = '';
			},
				closeMentorEditFormModal() {
					this.isMentorEditFormModalVisible = false;
				},
				openMentorEditFormModal() {
					this.isMentorEditFormModalVisible = true;
					this.$refs.MentorEditForm.loadinitial();
				},
        countDownAuthChanged(dismissAuthCountDown) {
          this.dismissAuthCountDown = dismissAuthCountDown;
        },
				moveToStep(stepId) {
					if(this.showFutureSteps == true) {
						this.activeStep = stepId;
						this.$refs.MenteeProgressComponent.reloadStep(stepId);
					}
				},
        hide() {
					this.close();
        },
        close() {
					this.$parent.closeUserDetail();
        },
        capitalizeFirstLetter(string) {
            if (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        phoneNumberFormat() {
            var phone_val = this.phoneNo;
            if (phone_val) {
                this.phoneNo = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            }
        },
        phoneNumberValidRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        formatStatus(status) {
            var status_text = 'Activate';
            if (status == 'ACTIVE' || status == 'Active') {
                status_text = 'Inactivate';
                this.status_text_color = 'text-red';
            }
            return status_text;
        },
        showMoreTaskLists() {
            if (!this.show_more_tasklists) {
                this.show_more_tasklists = true;
                this.see_more_tasklists_text = 'See less';
            } else {
                this.show_more_tasklists = false;
                this.see_more_tasklists_text = 'See all';
            }
        },
        showMoreAssessments() {
            if (!this.show_more_assessments) {
                this.show_more_assessments = true;
                this.see_more_assessments_text = 'See less';
            } else {
                this.show_more_assessments = false;
                this.see_more_assessments_text = 'See all';
            }
        },
        showMoreCourses() {
            if (!this.show_more_courses) {
                this.show_more_courses = true;
                this.see_more_courses_text = 'See less';
            } else {
                this.show_more_courses = false;
                this.see_more_courses_text = 'See all';
            }
        },
        showMoreForms() {
            if (!this.show_more_forms) {
                this.show_more_forms = true;
                this.see_more_forms_text = 'See less';
            } else {
                this.show_more_forms = false;
                this.see_more_forms_text = 'See all';
            }
        },
        goToViewForm(formId) {
            axios.
						get('/enterprise-admin/view-form/'+formId+'/'+this.userId+'/'+this.accountId, {
            })
            .then(response =>  {        
                window.open(process.env.API_ENDPOINT + '/forms/' +response.data.filepath, '_blank');                        
            })
            .catch(function(err) {
                console.log("Come here"+ err);
            });
        },
        getUserDetails() {
					this.loading = true;
					this.displayMentorEdit = 2;
					this.pathwayProgressLoading = true;
            axios.get('/enteprise-admin/user-details/' + this.userId + '/' + this.accountId, {
                params: { enterprise_type: 'manage' }
            })
            .then(response =>  {
                this.loading = false;
                this.isUpdateMsg = false;
                this.isCanAddTransfer = response.data.isCanAddTransfer;
                this.display_firstName = this.capitalizeFirstLetter(response.data.first_name);
                this.display_lastName = this.capitalizeFirstLetter(response.data.last_name);
                this.display_email = response.data.email;
                this.firstName = this.capitalizeFirstLetter(response.data.first_name);
                this.lastName = this.capitalizeFirstLetter(response.data.last_name);
                this.email = response.data.email;
                this.phoneNo = response.data.phone_no;
                this.status = response.data.status;
                this.userType = response.data.user_type;
                this.accountName = response.data.account_name;

                this.assignedTaskLists = response.data.user_tasklist;
                this.assignedTaskListsCount = response.data.user_tasklist.length;
                this.taskListsSelected = response.data.taskListsSelected;
                
                this.assignedAssessments = response.data.user_assessments;
                this.assignedAssessmentsCount = response.data.user_assessments.length;
                this.assessmentsSelected = response.data.assessmentsSelected;
                
                this.assignedCourses = response.data.user_courses;
                this.assignedCoursesCount = response.data.user_courses.length;
                this.courseSelected = response.data.coursesSelected;
                
                this.userInfo.id = this.userId;
                this.userInfo.first_name = this.firstName;
                this.userInfo.last_name = this.lastName;
                this.userInfo.email = this.email;
                this.userInfo.is_primaryadmin = response.data.is_primaryadmin;
                this.userInfo.accountId = this.accountId;

								this.editpathwaySelected = response.data.mentee_pathway;
								this.editShowFutureSteps = response.data.show_future_steps;
								this.editStepSelected = response.data.begin_step;
								this.existingPathway =  response.data.mentee_pathway;

                this.removedCourses = [];
                this.removedAssessments = [];
                this.removedTasklists = [];

								if((this.userType == 'mentor' || this.userType == 'mentee') && (this.editpathwaySelected)) {
									this.displayMentorEdit = 2;
									axios('/desktop/v2/get-mentee-details', {
										method: 'GET',
										params: {
											mentee_id: this.menteeId,
											accountId: this.accountId, 
										}
									})
									.then(resp => {
										let data = resp.data;
										this.menteeFirstName = data.mentee_first_name;
										this.menteeShortName = data.mentee_short_name;
										this.repCount = data.rep_count;
										this.mentorsAssigned = data.mentors_assigned;
										this.menteeFlag = data.mentee_flag;
									})
									.catch(() => {});
									axios('/desktop/v2/pathway/get-mentee-pathway-progress-enterpriseadmin', {
										method: 'GET',
										params: {
											account_id: this.accountId, 
											mentee_id: this.menteeId, 
											pathway_id: this.editpathwaySelected,
										}
									})
									.then(resp => {
										let data = resp.data;
										this.pathwayStepsData = data;
										this.pathwayProgressLoading = false;
										this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
										if (this.activeStep) {
											this.displayMentorEdit = 1;
										}
										else {
											this.displayMentorEdit = 0;
										}
										this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
										this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
									})
									.catch(() => {});
								}
								else {
									this.displayMentorEdit = 0;
								}
                
                axios('/get-pathway-add-mentee',
                  {
                    method: 'GET',
                    params: {
                      account_id: this.accountId,
                    }
                  },
                )
                .then(response => {
                      if(this.userType == 'mentor') {
                        this.editPathwayList = [];
                          var list =  { id: 0, pathwayName: 'No Pathway' };
                          this.editPathwayList.push(list);
                          for(var i=0; i < response.data.length; i++) {
                            var list = {id: response.data[i].id, pathwayName: response.data[i].pathwayName};
                            this.editPathwayList.push(list);
                          }
                      }
                      else {
                          this.editPathwayList = response.data;
                      }
                      
                        for(var i=0; i<this.editPathwayList.length; i++) {
                            if(this.editpathwaySelected == this.editPathwayList[i].id) {
                                this.getPathwaySteps();
                            }
                            
                        }
                 })
                .catch(error => {

                });

            })
            .catch(function(error) {
                console.log(error);
            });
        },
          getPathwaySteps() {
            this.pathwaySteps = [];
            axios('/get-pathway-steps-name',
                {
                  method: 'GET',
                  params: {
                    pathway_id: this.editpathwaySelected,
                  }
                },
              )
              .then(response => {
                    this.defaultstep = response.data[0].id;            
                    this.pathwaySteps = response.data;
               })
              .catch(error => {

              });
          },

        updateUser() {
            this.$validator.validateAll().then((result) => {
                if(!result) {
                    return;
                }
                axios('/enterpriseadmin/update-user',
                {
                    method: 'POST',
                    data: {
                        "user_id" : this.userId,
                        "first_name": this.firstName,
                        "last_name": this.lastName,
                        "email": this.email,
                        "phone_no": this.phoneNo,
                        "tasklists_assigned": this.taskListsSelected,
                        "assessments_assigned": this.assessmentsSelected,
                        "courses_assigned": this.coursesSelected,
                        "user_type": this.userType,
                        'removed_courses': this.removedCourses,
                        'removed_tasklists': this.removedTasklists,
                        'removed_assessments': this.removedAssessments,
                        'accountId': this.accountId,
                        "pathway_assigned": this.editpathwaySelected,
                        "show_future_steps": this.editShowFutureSteps,
                        "begin_step": this.editStepSelected,
                        "existing_pathway": this.existingPathway,
                    }
                },
                )
                .then(()=> {
                    this.isUpdateMsg = true;
                    this.clearFlashMessage();
                    this.getUserDetails();
                })
                .catch(() => {
                });
            }).catch(() => {
                // catches the error;
            });
        },
        openResetLinkModal() {
            let element = document.getElementById('userTab');    
            element.scrollIntoView(true);
            this.isUserResetLinkModal = true;
            this.$refs.user_reset_modal_popup.setUserInfo(this.userInfo);
        },
        closeResetLinkModal() {
            this.isUserResetLinkModal = false;
            this.$refs.user_reset_modal_popup.setUserInfo({});
            this.clearFlashMessage();
        },
        getFontColor(status) {
            if (status == 'ACTIVE' || status == 'Active')
                return 'text-red';
            else
                return 'text-green';
        },
        openStatusModal(status) {
            var user = {
                first_name: this.firstName,
                last_name: this.lastName,
                id: this.userId,
                accountId: this.accountId,
            }
            if (status == 'ACTIVE' || status == 'Active') {
                let element = document.getElementById('userTab');    
                element.scrollIntoView(true);
                this.isUserInactivateModal = true;
                this.$refs.user_inactivate_modal.setUserInfo(user);
            } else {
                let element = document.getElementById('userTab');    
                element.scrollIntoView(true);
                this.isUserActivateModal = true;
                this.$refs.user_activate_modal.setUserInfo(user);
            }
        },
        closeUserActivateModal() {
            this.isUserActivateModal = false;
        },
        closeUserInactivateModal() {
            this.isUserInactivateModal = false;
        },
        openTransferLinkModal() {
            this.isTransferLinkModal = true;
            this.$refs.add_transfer_modal_popup.fetchLocationsListitems(this.userInfo.id);
        },
        closeTransferLinkModal(msg) {
					if(msg) {
						this.success_auth_message = msg;
						this.dismissAuthCountDown = 5;
					}
					this.isTransferLinkModal = false;
        },
        getCourseSelected(event) {
            let cid = event.target.value;
            if(event.target.checked == true) {
							this.coursesSelected.push(cid);
							const ItemIndex = this.removedCourses.indexOf(cid);
							if(ItemIndex > -1) {
								this.removedCourses.splice(ItemIndex, 1); 
							}
            }
            else {
                const removeItemIndex = this.coursesSelected.indexOf(cid);
                this.removedCourses.push(cid);
                if(removeItemIndex > -1) {
                    this.coursesSelected.splice(removeItemIndex, 1); 
                }
            }
        },
        getAssessmentSelected(event) {
            let aid = event.target.value;
            if(event.target.checked == true) {
               this.assessmentsSelected.push(aid);
            }
            else {
                const removeItemIndex = this.assessmentsSelected.indexOf(aid);
                this.removedAssessments.push(aid);
                if(removeItemIndex > -1) {
                    this.assessmentsSelected.splice(removeItemIndex, 1); 
                }
            }
        },
        getTasklistSelected(event) {
            let tid = event.target.value;
            if(event.target.checked == true) {
               this.taskListsSelected.push(tid);
            }
            else {
                const removeItemIndex = this.taskListsSelected.indexOf(tid);
                this.removedTasklists.push(tid);
                if(removeItemIndex > -1) {
                    this.taskListsSelected.splice(removeItemIndex, 1); 
                }
            }
        },
        getCourseModuleInfo(userId, courseId, elementName, index) {
            //remove
            this.$refs['show_icon_' + index][0].classList.remove('show_icon');
            this.$refs['hide_icon_' + index][0].classList.remove('hide_icon')

            //add
            this.$refs['show_icon_' + index][0].classList.add('hide_icon');
            this.$refs['hide_icon_' + index][0].classList.add('show_icon');
            
            // console.log(elementName)
            // console.log(this.$refs[elementName][0])
            this.$refs[elementName][0].getModules(userId, courseId, true);
        },
        hideCourseModuleInfo(userId, courseId, elementName, index) {
            //remove
            this.$refs['show_icon_' + index][0].classList.remove('hide_icon');
            this.$refs['hide_icon_' + index][0].classList.remove('show_icon')

            //add
            this.$refs['show_icon_' + index][0].classList.add('show_icon');
            this.$refs['hide_icon_' + index][0].classList.add('hide_icon');
            
            this.$refs[elementName][0].getModules(userId, courseId, false);
        },
        clearFlashMessage() {
            setTimeout(() => {
                this.statusUpdateSuccessMsg = '';
                this.resetLinkSuccessMsg = '';
            }, 2000);
        },
				loadinitial() {
					this.loading = true;
					this.displayMentorEdit = 0;
					this.menteeId = this.userId;
					this.closeTransferLinkModal();
					this.closeMentorEditFormModal();
					this.getUserDetails();
				},
    },
    created() {
        this.loading = true;
				//this.menteeId = this.userId;
        //this.getUserDetails();

    }
}
</script>
<style scoped>

.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header { border-bottom: none; }
.modal-title { font-weight: 900; }
.modal-footer { border-top: none; }
.manage_header { padding: 0 1rem; 
    width: 100%;
    top: 20px;
    display: inline-block;
    z-index: 9999;
    }
.user-info { padding: 0.5rem 1.5rem !important; margin-top: 25px; z-index: 1; }

.uemail { font-size: 12px; font-style: italic; margin: 2px 0; }
.accountname { font-size: 13px; font-weight: 900; margin: 4px 0 10px 0; }
.mheading_1 { width: 5%; float: left; }
.mheading_2 { width: 31%; float: left; }
.mheading_3 { 
    width: 5%;
    margin: 15px 50px 0 0;
    font-size: 15px;
    font-weight: 900;
    color: #00Acee; 
    float: left; 
}
.mheading_4 { width: 5%; float: left;  }
.link_btn { font-weight: 900; cursor: pointer; }
.input_label { font-weight: 900; }
.edit_row { width: 95%; margin-top: 10px; }
.finput { background-color: #efefef !important; height: calc(1.15em + 0.75rem + 2px) !important; font-size: 0.9rem !important; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.hr_line { 
    margin: 0px -50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
 }
.hr_line_2 { margin: 10px 0px 10px 0px; width: 92%; }
.assigned_heading_1 { width: 80%; float: left; }
.assigned_heading_2 { width: 10%; float: left; }
.assigned_heading_3 { width: 10%; float: left; }
.pad-15 { padding: 0 15px; }
.row_item_readonly { width: 100%; margin: 10px 0; padding: 0 0 0 10px; }
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.link_btn_highlight { font-weight: 900; cursor: pointer; text-decoration: underline; }
.assigned_head_3 { width: 15%; float: left; }
.assigned_head_4 { width: 10%; float: left; }
.assigned_thead_1 { width: 90%; float: left; }
.assigned_form_h1 { width: 90%; float: left; }
.assigned_form_h2 { width: 10%; float: left; }
.forms_item_1 { width: 90%; float: left; }
.forms_item_2 { width: 10%; float: left; }
.courses_head_1 { width: 56%; float: left; }
.courses_head_2 { width: 22%; float: left; }
.courses_head_3 { width: 12%; float: left; }
.courses_head_4 { width: 10%; float: left; }
.courses_item_1 { width: 58%; float: left; }
.courses_item_2 { width: 20%; float: left; }
.courses_item_3 { width: 12%; float: left; }
.courses_item_4 { width: 10%; float: left; }
.status_link { text-decoration: underline !important; font-weight: 900; cursor: pointer; }
.offcanvas_link { color: #00acee !important; text-decoration: underline !important; font-weight: 900; cursor: pointer; }
.show_icon { 
  display: show;
}
.hide_icon { 
  display: none;
}
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/view_user_detail_manage.vue